var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Play = function Play(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 14 14' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'Paly icon'
      ),
      React.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        React.createElement('path', { d: 'M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6', fill: 'currentColor' }),
        React.createElement('path', { stroke: 'currentColor', d: 'M5 4v6l5-3z' })
      )
    )
  );
};
/*eslint-enable */

export default Play;
//# sourceMappingURL=Play.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Play.js